import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignTabBase, CampaignTabItem } from '../shared/campaign-tab-base';

export type TabItem = CampaignTabItem;

/**
 * Horizontal tab navigation component for displaying campaign tabs with efficient item tracking.
 * @component
 * @selector app-horizontal-tab
 * @example
 *   <app-horizontal-tab [inputProp]="sample_value1" (outputEvent)="handler()"></app-horizontal-tab>
 * @input any inputProp - Inherited input properties from CampaignTabBase used to configure the tab content and state.
 * @output any outputEvent - Inherited output events from CampaignTabBase used to notify parent components of tab interactions and state changes.
 * @method trackByIndex Returns the current index for use in Angular iteration tracking.
 * @method trackByValue Returns an item's value property, or the item itself, for stable trackBy optimization.
 * @method trackById Returns an item's id property, or the item itself, for stable trackBy optimization.
 * @method trackByString Returns the item itself for use as a trackBy key.
 * @remarks Extends CampaignTabBase and participates in Angular component lifecycle through inherited hooks and behavior.
 */
@Component({
  selector: 'app-horizontal-tab',
  imports: [CommonModule],
  templateUrl: './horizontal-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './horizontal-tab.component.scss',
})
export class HorizontalTabComponent extends CampaignTabBase {
  trackByIndex(index: number): number {
    return index;
  }
  trackByValue(_: number, item: any): any {
    return item?.value ?? item;
  }
  trackById(_: number, item: any): any {
    return item?.id ?? item;
  }
  trackByString(_: number, s: any): any {
    return s;
  }
}
